import usernameSearch from "./requests/usernameSearch";
import {getSupplier, getSuppliers, supplierKey} from './sessionVariable';

const validUsername = new RegExp('^(?=.{3,64}$)[a-z0-9.]{3,}@[a-z0-9.]{3,}$');
const validPhoneNumber = new RegExp('^[0-9]{10,11}$');
const validPassword = new RegExp('^[A-Za-z0-9]{8,20}$');
const validOrderReference = new RegExp('^.{3,64}$');

export const checkUsernameValid = async (user, realm) => {
  const username = `${user}@${realm}`;

  if (validUsername.test(username)) {
    try {
      return await usernameSearch(user, realm);
    } catch (err) {
      console.error(err);
    }
  }

  return "The username should be a minimum of 3 characters. Only numbers, lower case letters and ‘.’ are allowed";
}

export const generateShortID = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 6; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

export const checkPhoneNumberValid = (phoneNumber) => {
  if (validPhoneNumber.test(phoneNumber)) {
    return true;
  }
  return "Phone number must be 10 or 11 digits.";
};

export const checkPasswordValid = (password) => {
  if (validPassword.test(password)) {
    return true;
  }
  return "Password must be 8–20 characters long and contain only letters and numbers.";
};

export const checkOrderReferenceValid = (reference) => {
  if (validOrderReference.test(reference)) {
    return true;
  }
  return "Order reference must be 3–64 characters long.";
};

export function createRequestBody(phoneNumber, address, uprnRequest, isZen) {
  if (!phoneNumber && !address) {
    throw new Error('No phone number or address provided');
  }

  if (phoneNumber) {
    return JSON.stringify({ phoneNumber });
  }

  const { addressReference, postCode } = address;
  const { addressReferenceNumber, districtCode, uprn, qualifier } = addressReference;

  if(uprnRequest && !isZen){
    return  JSON.stringify({address_key:uprn,postcode:postCode,productTypes:["fttp"],promocode:""});
  }
  
  if(qualifier === 'Silver' && isZen){
    return JSON.stringify({
      postCode,
      goldAddressKeyAvailabilityRequest: null,
      uprn
    })
  }

  return JSON.stringify({
    postCode,
    goldAddressKeyAvailabilityRequest: {
      addressReferenceNumber,
      districtCode
    },
    uprn
  })
}

export async function isOnboarded(supplier) {
  const suppliers = await getSuppliers();
  return suppliers[supplier] === 1;
}
